import { Box, Button } from '@mui/material';

import useBlobFile from 'hooks/useBlobFile';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { useMutateRelatorioAnalitico } from 'pages/financeiro/reembolso/manutencao-reembolso/hooks';

type ManutencaoReembolsoDownload = {
    idApuracao: number;
    idStatusApuracao: number;
    idStatusApuracaoRelatorio: number;
    dsLink: string;
    cdApuracaoFormatado: string;
};

export function ManutencaoReembolsoDownload({
    idApuracao,
    idStatusApuracao,
    idStatusApuracaoRelatorio,
    dsLink,
    cdApuracaoFormatado,
}: ManutencaoReembolsoDownload) {
    const requestOptions: RequestOptionsType = {
        url: '/financeiro/apuracaolojapromocaovenda/exportar/csv',
        filter: [{ property: 'idApuracao', operator: 'eq', value: idApuracao }],
        sort: [{ property: 'idApuracao', direction: 'DESC' }],
    };

    const { isLoadingFile, downloadFile } = useDownloadFile({ requestOptions });
    const { urlToFile, isFetching } = useBlobFile();
    const { isLoading, handlerRelatorioAnalitico } = useMutateRelatorioAnalitico();
    const isFinalizadoSucesso = idStatusApuracao === 4;
    const isRelatorioFinalizadoSucesso = idStatusApuracaoRelatorio === 4 && dsLink;
    const isRelatorioPendente = idStatusApuracaoRelatorio === 1;
    const isRelatorioFinalizadoErro = idStatusApuracaoRelatorio === 5;
    const disabledRelatorioAnalitico = !isFinalizadoSucesso || (!isRelatorioFinalizadoSucesso && !isRelatorioPendente && !isRelatorioFinalizadoErro);

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
                color="info"
                variant="outlined"
                loading={isLoadingFile}
                disabled={!isFinalizadoSucesso}
                sx={{ px: 1, py: 0 }}
                onClick={() =>
                    downloadFile({
                        newRequestOptions: requestOptions,
                        directDownload: true,
                    })
                }
            >
                Relatório sintético
            </Button>

            <Button
                color={isRelatorioFinalizadoSucesso ? 'success' : 'primary'}
                variant="outlined"
                sx={{ px: 1, py: 0 }}
                disabled={disabledRelatorioAnalitico}
                loading={isLoading || isFetching}
                onClick={() => {
                    if (isRelatorioFinalizadoSucesso) {
                        const extension = dsLink?.split('.').pop();

                        urlToFile({
                            url: dsLink,
                            filename: `relatorio_analitico_${cdApuracaoFormatado}.${extension}`,
                        });
                    } else {
                        handlerRelatorioAnalitico(idApuracao);
                    }
                }}
            >
                {isRelatorioPendente || isRelatorioFinalizadoErro ? 'Gerar relatório analítico' : 'Relatório analítico'}
            </Button>
        </Box>
    );
}
